WiseMetering.Views.ShowNavigatorIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/navigator/show',
    title: () => i18next.t('modal.title.integrations.show'),

    edit: function() {
        return new WiseMetering.Views.EditNavigatorIntegration({ model: this.model });
    },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site(),
            configurationName: this.model.configuration().get('name'),
            indicatorKindName: this.model.indicatorKind().get('name'),
            integrationIndicators: this.model.integrationIndicators()
        };
    }
});
